import { useForm } from 'react-hook-form';

export interface RecoveryPasswordForm {
  email: string;
}

export const useRecoveryPasswordForm = () => {
  const { register, handleSubmit, formState: { errors }, getValues } = useForm<RecoveryPasswordForm>();

  return {
    controls: {
      email: register('email', { required: 'El email es requerido.' }),
    },
    handleSubmit,
    errors,
    getValues
  };
};
